import { Component, OnInit, Input } from '@angular/core';

import { File } from 'app/models/file';
import { FileType } from 'app/models/file-type.enum';
import { FileIconType } from 'app/models/file-icon-type.enum';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-document-item',
  templateUrl: './document-item.component.html',
  styleUrls: ['./document-item.component.scss']
})
export class DocumentItemComponent implements OnInit {
  @Input() file: File;
  public fileIconType: string;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.fileIconType = `icon-${FileIconType[this.enumRrverse(FileType,
      this.file.contentType || this.file.source)]}`;
  }

  enumRrverse(enumList, value) {
    const keys = Object.keys(enumList).filter(k => typeof enumList[k as any] === 'string');
    const values = keys.filter(k => enumList[k as any] === value);
    return values[0];
  }

  onSelect() {
    this.router.navigate(
      ['file', this.file.id],
      { relativeTo: this.activatedRoute }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/document-item/document-item.component.ts